// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
export const ComponentContentWithGalleryFragmentDoc = gql`
    fragment componentContentWithGallery on ComponentContentWithGallery {
  content {
    ...contentComponentItem
  }
  gallery {
    ... on GalleryItem {
      image {
        ...imageLarge
      }
    }
  }
}
    ${ContentComponentItemFragmentDoc}
${ImageLargeFragmentDoc}`;